module.exports = __webpack_public_path__ + "banner.fb042fa05f2568c21f3a.jpg";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/aamva/media/img/banner.jpg
// module id = ../../../../../src/assets/aamva/media/img/banner.jpg
// module chunks = styles